<template>
  <vs-popup
    class="popup"
    button-close-hidden
    :active.sync="popUpShown"
    @close="closePopup"
  >
    <img
      class="vs-popup--close-button"
      :src="require('@/assets/shipo-popup-icon-close.svg')"
      @click="closePopup"
    >
    <div class="w-full text-xl font-semibold">
      Report Cargo Stolen Accident
    </div>
    <div
      class="edit-cargo-form popup-content-size text-black mt-4"
    >
      <div class="font-semibold text-primary mb-4 section-title">
        Trip Data
      </div>
      <div class="grid grid-cols-2 gap-6 mb-4">
        <div>
          <label class="block mb-1 font-semibold">Supply To Vessel</label>
          <p class="w-full p-3 rounded-lg text-black">
            {{ localForm.name_of_vessel || '-' }}
          </p>
        </div>
        <div>
          <label class="block mb-1 font-semibold">Trip Number</label>
          <p class="w-full p-3 rounded-lg text-black">
            {{ localForm.trip_number || '-' }}
          </p>
        </div>
        <div>
          <label class="block mb-1 font-semibold">Tug Name</label>
          <p class="w-full p-3 rounded-lg text-black">
            {{ localForm.tug || '-' }}
          </p>
        </div>
        <div>
          <label class="block mb-1 font-semibold">Barge Name</label>
          <p class="w-full p-3 rounded-lg text-black">
            {{ localForm.barge || '-' }}
          </p>
        </div>
        <div>
          <label class="block mb-1 font-semibold">Route</label>
          <p class="w-full p-3 rounded-lg text-black">
            {{ localForm.route || '-' }}
          </p>
        </div>
        <div>
          <label class="block mb-1 font-semibold">Cargo Loaded</label>
          <p class="w-full p-3 rounded-lg text-black">
            {{ localForm.cargo_loaded || '-' }}
          </p>
        </div>
      </div>
      <div class="font-semibold text-primary mb-4 section-title">
        Accident Details
      </div>
      <div class="mb-4 w-1/2 pr-3">
        <label class="block mb-1 font-semibold">Date of Accident</label>
        <div class="w-full date-picker-wrapper">
          <date-picker
            class="w-full"
            type="date"
            format="DD MMM YYYY"
            v-model="localForm.date_of_incident"
            placeholder="Select Date of Accident"
            style="min-width: 260px;"
            :disabled-date="disabledDate"
          />
          <span
            v-if="!localForm.date_of_incident"
            class="text-danger text-sm absolute-bottom-5 left-0"
          >*Required</span>
        </div>
      </div>
      <div class="grid grid-cols-2 gap-6 mb-4">
        <div>
          <label class="block mb-1 font-semibold">Est. Lost by Visual Cargo (Ton)</label>
          <vs-input
            class="w-full"
            type="number"
            v-model="localForm.estimated_lost_cargo"
            placeholder="Est. Lost by Visual Cargo"
          />
          <span
            v-if="!localForm.estimated_lost_cargo"
            class="text-danger text-sm absolute-bottom-5 left-0"
          >*Required</span>
        </div>
        <div>
          <label class="block mb-1 font-semibold">Location Of Accident</label>
          <vs-input
            class="w-full"
            type="text"
            v-model="localForm.location_of_incident"
            placeholder="Location of Accident"
          />
          <span
            v-if="!localForm.location_of_incident"
            class="text-danger text-sm absolute-bottom-5 left-0"
          >*Required</span>
        </div>
      </div>
      <div class="mb-4">
        <label class="block mb-1 font-semibold">Remark</label>
        <textarea
          class="w-full p-3 rounded-lg border border-gray-200 text-area"
          rows="4"
          v-model="localForm.remarks"
        />
      </div>
      <div class="mb-4">
        <label class="block mb-1 font-semibold">Evidence</label>
        <input
          :disabled="isUploadingImages"
          ref="fileInput"
          type="file"
          class="hidden"
          accept="image/jpeg,image/jpg,image/png"
          @change="onFileChange"
          multiple
        >
        <vs-button
          class="flex w-full text-gray-500 p-3 items-center mb-2"
          type="button"
          @click="triggerFileInput"
          style="background-color: #F1F1FD"
          :disabled="evidenceImages.length >= 5 || isUploadingImages"
        >
          <div class="flex flex-row items-center justify-start pr-2 w-full">
            <img
              :src="require('@/assets/shipo-icon-edit-upload-primary.svg')"
              class="flex mr-2 h-6"
            >
            <div class="truncate">
              Select image(s) to upload
            </div>
          </div>
        </vs-button>
        <p class="text-sm text-gray-500 mb-3">
          Max. 5 images allowed (.jpg, .jpeg and .png)
        </p>
        <div class="self-center w-full mb-3">
          <vs-progress
            indeterminate
            v-show="isUploadingImages"
            color="secondary"
          />
        </div>
        <div
          v-if="evidenceImages.length"
          class="flex flex-wrap gap-3"
        >
          <div
            v-for="(img, index) in evidenceImages"
            :key="index"
            class="image-container"
          >
            <img
              :src="img.dataUrl || img.download_url"
              alt="Preview"
              class="image-preview"
            >
            <vs-icon
              class="remove-button cursor-pointer"
              icon="close"
              color="#EE443F"
              size="small"
              @click="removeImage(index)"
            />
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-4 mt-8">
        <button
          class="btn-cancel"
          @click="closePopup"
        >
          Cancel
        </button>
        <button
          class="btn-update"
          @click="updateStolenCargo"
        >
          Save Stolen Cargo
        </button>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import { mapGetters } from 'vuex'

import DatePicker from '@/components/datePicker'
import { MAX_FILE_UPLOAD_SIZE_BYTES } from '@/fixtures/Constants'

export default {
  components: {
    DatePicker
  },
  props: {
    active: {
      type: Boolean,
      required: true
    },
    form: {
      type: Object,
      required: true
    },
    activeTab: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      localForm: { ...this.form },
      popUpShown: this.active,
      isLoading: false,
      evidenceImages: [],
      isUploadingImages: false,
      evidenceFileIds: []
    }
  },
  computed: {
    ...mapGetters({
      detailCargoStolen: 'CargoStolen/detailCargoStolen',
      attachments: 'CargoStolen/attachments'
    }),
    disabledDate() {
      return (date) => {
        if (!this.localForm.trip_start) {
          return false;
        }
        
        const tripStartDate = new Date(this.localForm.trip_start);
        return date < tripStartDate;
      };
    }
  },
  watch: {
    form: {
      handler(newVal) {
        this.localForm = { ...newVal };
        if (newVal.date_of_incident) {
          this.localForm.date_of_incident = new Date(newVal.date_of_incident);
        }
        if (newVal.id) {
          this.fetchDetail();
        }
      },
      deep: true,
      immediate: true
    },
    active: {
      handler(val) {
        this.popUpShown = val
        if (val && this.localForm.id) {
          this.fetchDetail();
        }
      }
    },
    detailCargoStolen: {
      handler(detail) {
        if (detail) {
          this.localForm = {
            ...this.localForm,
            ...detail,
            date_of_incident: detail.date_of_incident ? new Date(detail.date_of_incident) : null
          };
          this.evidenceFileIds = detail.evidences.map(ev => ev.file_id || ev.fileId)
          this.evidenceImages = detail.evidences
        } 
      },
      immediate: true
    },
    attachments: {
      handler(newAttachments) {
        if (newAttachments && Array.isArray(newAttachments) && newAttachments.length) {
          const newFileIds = newAttachments
            .map(att => att.fileId || att.file_id || att.id)
            .filter(id => id && !this.evidenceFileIds.includes(id))
          if (newFileIds.length) {
            this.evidenceFileIds = [...this.evidenceFileIds, ...newFileIds]
          }
        }
      }
    }
  },
  methods: {
    async fetchDetail() {
      if (!this.localForm.id) return;
      
      this.isLoading = true
      try {
        await this.$store.dispatch('CargoStolen/fetchDetailCargoStolen', this.localForm.id)
      } catch (err) {
        this.showFailedNotification(this, 'Failed to fetch cargo stolen detail, please try again')
      } finally {
        this.isLoading = false
      }
    },
    async updateStolenCargo() {
      if (!this.localForm.date_of_incident) {
        this.showFailedNotification(this, 'Date of Accident is required')
        return
      }
      
      if (!this.localForm.estimated_lost_cargo || this.localForm.estimated_lost_cargo <= 0) {
        this.showFailedNotification(this, 'Estimated Lost Cargo must be greater than 0')
        return
      }
      
      if (!this.localForm.location_of_incident || this.localForm.location_of_incident.trim() === '') {
        this.showFailedNotification(this, 'Location of Accident is required')
        return
      }

      try {
        const evidence = (this.evidenceFileIds && this.evidenceFileIds.length)
          ? this.evidenceFileIds.map(fileId => ({ file_id: fileId }))
          : []

        await this.$store.dispatch('CargoStolen/putCargoStolen', {
          id: this.localForm.id,
          form: {
            location_of_incident: this.localForm.location_of_incident,
            date_of_incident: this.localForm.date_of_incident,
            estimated_lost_cargo: this.localForm.estimated_lost_cargo,
            ...(this.localForm.remarks ? { remarks: this.localForm.remarks } : {}),
            evidence: evidence
          }
        })
        this.showSuccessNotification(this, 'Stolen cargo updated successfully')
        this.$emit('updated')
        this.closePopup()
      } catch ({error}) {
        this.showFailedNotification(this, error.errors && error.errors.length ? Array.isArray(error.errors[0]) ? error.errors[0][0].message : error.errors[0].message : error.message || 'Failed to update stolen cargo, please try again')
      }
    },
    closePopup() {
      this.evidenceFileIds = []
      this.$store.commit('CargoStolen/SET_ATTACHMENTS', [])
      this.evidenceImages = []
      this.isUploadingImages = false
      this.$emit('update:active', false)
      this.$emit('close')
    },
    triggerFileInput() {
      this.$refs.fileInput?.click()
    },
    async onFileChange(event) {
      const files = Array.from(event.target.files)
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png']
      const maxImages = 5
      const maxFileSize = MAX_FILE_UPLOAD_SIZE_BYTES

      if (this.evidenceImages.length + files.length > maxImages) {
        this.showFailedNotification(this, `Maximum ${maxImages} images allowed`)
        event.target.value = null
        return
      }

      const validFiles = []
      for (const file of files) {
        if (!allowedTypes.includes(file.type)) {
          this.showFailedNotification(this, 'Only .jpg, .jpeg and .png files are allowed')
          continue
        }

        if (file.size > maxFileSize) {
          this.showFailedNotification(this, 'File size must not exceed 5 MB')
          continue
        }

        validFiles.push(file)
      }

      if (validFiles.length === 0) {
        event.target.value = null
        return
      }

      this.isUploadingImages = true

      try {
        const uploadResponse = await this.$store.dispatch('CargoStolen/postCargoStolenFiles', validFiles)
        
        if (uploadResponse && Array.isArray(uploadResponse) && uploadResponse.length) {
          const newFileIds = uploadResponse
            .map(att => att.fileId || att.file_id || att.id)
            .filter(id => id && !this.evidenceFileIds.includes(id))
          if (newFileIds.length) {
            this.evidenceFileIds = [...this.evidenceFileIds, ...newFileIds]
          }
        }
        
        const readPromises = validFiles.map((file, index) => new Promise((resolve) => {
          const reader = new FileReader()
          reader.onload = e => {
            const uploadResult = uploadResponse && uploadResponse[index] ? uploadResponse[index] : null
            this.evidenceImages.push({
              file: file,
              dataUrl: e.target.result,
              isExisting: false,
              file_id: uploadResult ? uploadResult.fileId : null
            })
            resolve()
          }
          reader.onerror = () => {
            this.showFailedNotification(this, `Failed to read file: ${file.name}`)
            resolve()
          }
          reader.readAsDataURL(file)
        }))

        await Promise.all(readPromises)
      } catch (err) {
        this.showFailedNotification(this, 'Failed to upload files, please try again')
      } finally {
        this.isUploadingImages = false
        event.target.value = null
      }
    },
    removeImage(index) {
      const image = this.evidenceImages[index]
      const fileId = image?.fileId || image?.file_id
      if (fileId) {
        this.evidenceFileIds = this.evidenceFileIds.filter(id => id !== fileId)
      }
      this.evidenceImages.splice(index, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.popup {
  /deep/.vs-popup {
    @apply w-1/2;
    @apply rounded-2xl;

    &--title {
      @apply hidden;
    }

    &--content {
      @apply p-8;
      @apply relative;
      @apply m-0;
      @apply flex;
      @apply flex-col;
      @apply w-full;
      @apply items-center;
      max-height: 90vh;
      overflow-y: auto;
      overflow-x: hidden;

      &-title {
        @apply text-2xl;
        @apply font-semibold;
        @apply text-grey;
        @apply mt-8;
      }

      @media only screen and (max-width: 767px) {
        max-height: 80vh;
      }
    }

    &--img {
      width: 152px;
    }

    &--close-button {
      @apply cursor-pointer;
      @apply absolute;
      width: 30px;
      top: 1rem;
      right: 1rem;
    }

    &--ok {
      @apply rounded-xl;
      @apply border-2;
      @apply mt-20;
      @apply py-4;
      @apply min-w-button;
      @apply font-semibold;
      height: calc( 1rem * 10 / 3 );

      &.shadow-secondary {
        -webkit-box-shadow: 0 8px 25px -8px rgba(var(--vs-secondary),1);
        box-shadow: 0 8px 25px -8px rgba(var(--vs-secondary),1);
      }

      &:focus {
        @apply outline-none;
        @apply border-none;
      }
    }

    p {
      @apply text-base;
      @apply text-grey-001;
    }

    @media only screen and (max-width: 767px) {
      @apply w-full;
      @apply self-end;
      @apply m-0;
      @apply rounded-b-none;
      @apply max-w-none;
      height: max-content;
    }
  }
}

.popup-content-size {
  width: 100%;
  overflow-x: hidden !important;
}
.btn-cancel {
  border: 1px solid #8b5cf6;
  color: #8b5cf6;
  background: #fff;
  border-radius: 8px;
  padding: 0.75rem 2rem;
  font-weight: 500;
  transition: background 0.2s;
  width: 100%;
}
.btn-cancel:hover {
  background: #f3f0ff;
}
.btn-update {
  background: #8b5cf6;
  color: #fff;
  border-radius: 8px;
  padding: 0.75rem 2rem;
  font-weight: 500;
  border: none;
  transition: background 0.2s;
  width: 100%;
}
.btn-update:hover {
  background: #7c3aed;
}

.text-area {
  background-color: #F1F1FD;
}
.image-container {
  display: inline-block;
  margin: 0;
  position: relative;
}
.image-preview {
  max-width: 150px;
  max-height: 150px;
  border: 1px solid #ccc;
  border-radius: 8px;
  object-fit: cover;
}
.remove-button {
  position: absolute;
  top: -8px;
  right: -8px;
  border: none;
  font-size: 18px;
  border-radius: 50%;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
.date-picker-wrapper,
.date-picker-wrapper * {
  width: 100% !important;
  min-width: 0 !important;
  box-sizing: border-box !important;
  max-width: 100% !important;
}
@media (max-width: 767px) {
  .popup-content-size {
    min-width: 0 !important;
    width: 100%;
    max-width: 100%;
    padding: 0 !important;
  }
  .section-title {
    font-size: 1.1rem;
    margin-top: 1.5rem;
    margin-bottom: 1rem;
  }
  .btn-cancel, .btn-update {
    width: 100%;
    margin: 0;
  }
}
</style>